import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const resetBranchVolumeDataSchema = z.object({
  branchId: z.string(),
});

export const resetBranchVolumeData = mutator({
  schema: resetBranchVolumeDataSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  description:
    "Clears a draft’s stored data and leaves its storage undecided again.",
  interactionType: "delete",
  // The rows that mark the draft as decided go only once its data is gone, so
  // the server deletes them after the Blobstore refs, outside the transaction.
  fn: async ({ args: { branch } }) => {
    if (branch.name === "main") {
      throw userFacingError("Live’s stored data can’t be reset.");
    }
  },
});
